// import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const useAuth = () => {

  const userInfo = localStorage.getItem('admin')
  const user = { loggedIn: userInfo };
  return user && user.loggedIn;
};

const ProtectedRoutes = () => {
  const isAuth = useAuth();
  return isAuth ? <Outlet /> : <Navigate to="/admin/login" />;
};

export default ProtectedRoutes;